export const english = {
  //home
  g1:"Gujarat State Agricultural Marketing, Gujarat(Gujarat Mandi)",
  g_home:" The Gujarat State Agricultural Marketing Board (Gujarat Mandi Board, GSAMB) was established to regulate and manage the buying, selling, and storage of agricultural produce. It ensures fair trade practices for farmers, traders, and buyers. GSAMB oversees the marketing of agricultural, horticultural, animal husbandry, and forestry products to maintain a smooth supply chain. It operates as an independent body with the power to own and manage properties.",
  q_link:"Quick Links",
  trader_reg:"Trader Registration",
  panel_reg:" Panel Engineer Registration",
  g2:"DIRECTOR OF AGRICULTURE MARKETING AND RURAL FINANCE",
  logout:"Logout",
  lang:"Language",
  main:"Main",
  home:"Home",
  tra_login:"Trader Login",
  gc_login:"GCA Login",
  spon_login:"Sponsor Login",
  pa_login:"Panel Engineer Login",
  dr_login:"District  Login",
  ap_login:"APMC Login",
  ho_login:"Head Office Login",
  

  //sidebar
  mis_dash:"MIS Dashboard",
  dash:"Dashboard",
  mis_download:"MIS Preview",
  mis_upload:"MIS Upload",
  utl:"Unified Trader License",
  p_eng:"Panel Engineer",
  t_app:"Trader Applications",
  a_app:"APMC Applications",
  new_app:"New Application",
  mu_app:"My Applications",
  pa_eng:"Panel Engineer Applications",
  pending:"Pending",
  pen:"tttt",
  approved:"Approved",
  rejected:"Query Raised",
  app:"Applications",
  schemeApplication:"Applications Schemes",
  formApplication:"Applications Forms",
  spon_app:"Sponsor Applications",
  registration:"Registration",
  agreement:"Agreement",
  new_reg:"New Registration", 
  new_agg:"New Agreement",
  my_app:"My Application",



  //mis
  dashboard:"Dashboard",
  app_recev:"Applications Received",
  y1:"1 Years",
  y3:"3 Years",
  app_pen:" Applications Pending ",
  lic_iss:"License Issued",
  amount_collected:"Amount Collected",
  reg_trader:"Registered Trader",
  month_app_rec:"Monthly Applications Received",
  app_rec_aptype:"Applications Received By Applicant Type",
  app_summ_apmc:"Applications Summary APMC",
  app_summ_district:"Applications Summary District",
  app_det:"Applicant Details",
  date_app:"Date Applied",
  reg_eng:"Registered Engineer",
  //reistration
  enter_detail:"Enter Details for License Application",
  reg_heading:" Please enter your details to sign up",
  title: "Title",
  applicantName:"Applicant Name",
  first_name: "First Name",
  middle_name: "Middle Name",
  last_name: "Last Name",
  gender: "Gender",
  registration_type: "Member Registration as a",
  applicant_type: "Applicant Type",
  entityType:"Applicant Type",
  mobile: "Mobile No",
  email: "Email id",
  password: "Password",
  confirm_password: "Confirm Password",
  sign_up: "Sign Up",
  enter_otp: "Enter OTP",
  verify: "Verify & Proceed",
  resend:"Resend OTP",
  get_otp:"Get OTP",
  otp_heading:"Please enter the OTP received at your E-mail to confirm your account ownership.",
  alreadyaccount:"Already have an account?",
  organisation:"Organisation",

  //login
  login:"Login",
  login_heading:"Please enter your details to sign in",
  username: "User Name",
  sign_in: "Sign In",
  forgot_password: "Forgot Password",
  remember:"Remember Me",
  create_account: "Create Account",
  request_again: "Request again",
  dontaccount:"Don’t have an account?",
  //steps of license application form
  basic_detail: "Basic Details",
  representatives: "Representatives",
  firm_info: "Firm Info",
  guarantors: "Guarantors",
  enclosures: "Enclosures & Declarations",
  payment: "Payment",
  otherDoc:"Additional other Documents",
  license:"New License Application",
  //basic details form
  trader_name: "Trader Name",
  register_with_apmc: "Register With APMC",
  placeOfBusiness:"Place of Business",
  license_type: "License Type",
  current_address: "Current Address",
  permanent_address: "Permanent Address",
  perAddress:"Permanent Address",
  registered_office_address: "Registered Office Address",
  regOffAddress:"Registered Office Address",
  address: "Address",
  at:"Address",
  post: "Post",
  taluka: "Taluka",
  district: "District",
  borderDistrict:"Border District",
  pan_card_no: "Pan Card No",
  election_card_no: "Election Card No",
  electionCardNo:"Election Card No",
  registered_email_id: "Registered Email Id",
  regEmailId:"Registered Email Id",
  bankDetails: "Bank Details",
  acct_no: "Bank Account No",
  ifsc_code: "IFSC Code",
  acct_type : "Account Type",
  bank_name : "Bank Name",
  branch_name: "Branch Name",
  agentName: "Agent Name",
  //buttons
  next: "Next",
  previous: "Previous",
  submit: "Submit",
  cancel: " Save & Pay Later",
  ok:"OK",
  can:"Cancel",
  retry_payment:"Retry Payment",
  download:"Download Reciept",
  add_more: "Add More",
  delete:"Delete",
  preview:"Preview",
  view:"View",
  review:"Review",
  preview_application: "Preview Application",
  make_your_payment: "Pay Now",
  upload: "Upload",
  modify: "Modify",
  ptp:"Proceed to payment",
  edit:"Edit",
  close:"Close",
  down:"Download",
  vdoc:"View Document",
  vdocs:"View Documents",
  upd:"Update",
  remove:"Remove",
  down_pdf:"Download Application",

  //representative
  name: "Name",
  age_in_year: "Age in Year",
  representative:"Representatives or Assistants",
  representative_heading: "Fill Representative or assistants Details:",
  representative_details: "Enter Representatives or assistants details for license application",

  //firm info form
  firm:"Partners/Members",
  firmDetails:"Firm Information",
  firm_heading: "Fill Partners or members Details:",
  firm_details: "If the applicant is a co-operative society, company, firm, or joint family",
  firm_name: "Firm/Co-operative Society/Company Name",
  entityName:"Firm/Co-operative Society/Company Name",
  firm_gst_no:
  "GST No. (If the applicant is a Co-operative Society, Firm, Company, or other entity.)",
  entityGstNo:"GST No.(Firm/Company/Co-operative Society/Other Entity)",
  firm_registration_no:
    "Registration No. (If the applicant is a Co-operative Society, Firm, Company, or other entity.)",
   entityRegistrationNo:
    "Registration No.(Firm/Company/Co-operative Society/Other Entity)",
  firm_pan_no:
    "PAN No. (If the applicant is a Co-operative Society, Firm, Company, or other entity.)",
  entityPanNo:  " Firm/Co-operative Society/Company Name/others PAN No.",

  fpo: "FPO (Farmer Producer Organization) Certificate (if applicable)",
  
  entityFpoNo:"FPO No.(Firm/Company/Co-operative Society/Other Entity)",

  //guarantors form
  guarantor:"Guarantor Details",
  guarantor_heading: "Fill Guarantor Details:",
  guarantors_details: "Enter Guarantor Details for License Application",
  "guarantorPanCard": "Upload Copy Of PAN Card",
  "guarantorPhoto": "Upload Profile Photo",
  "guarantorSignature": "Upload  Signature",
  "guarantorDeclaration": "Upload Gurantor Declaration",
  //enclosure form
  attachements: "Attachements",
  enclosures_heading: "Provide Supporting Documents for License Application-",
  "solvencyCertificate": "Solvency Certificate",
  "bankGuarntee": "Bank Guarantee",
  "bankBalanceCertificate": "Bank Balance Certificate",
  "panCardNo":"Pan Card No.",
  "panCard":"Pan Card",
  "itReturns": "Copies of IT Returns (for the last three years)",
  "itReturns_1": " IT Return 1",
  "itReturns_2": " IT Return 2",
  "itReturns_3": " IT Return 3",
  "itReturnDetail": "Copies of IT Returns (for the last three years)",
  declarationDetail:"Declaration",
  gstCertificateDocs: "GST Certificate",
  "electionCard": "Copy of Election Card",
  "chalanPayementLiceneseFeeDoc": "Challan in support of payment of license fees",
  "proofOfBusinessPalace": "Proof of place of business",
  "partnerShipDeed": "In case of a Partnership Firm, Copy of partnership deed",
  "traderSignature": "Trader Signature",
  agentSignature:"Agent Signature",
  "declarations": "Declaration",
  "enclousreDeclaration": "Enclosures Declaration",
  "affidavit":
    "Affidavit stating the probable place of business and the details of the Market Committee where the applicant is proposing to contest the election to the Market Committee.",
  "coOpSocietyByLaws":
    "In case of a Co-operative Society, Copy of Registration Certificate, Copy of Bye-Laws, Copy of Resolution for obtaining License, Copy of Last Audit Report, Copy of Income- Expenditure statement and Balance Sheet for the last three years.",
  "companyArticleAssociation":
    "In case of company, copy of article of association and Copy of Power of Attorney of Authorized Person.",
 payment_heading:"Payment details for license application",
  payment_successfull: " has been submitted successfully.",
  amount: "Amount",
  transaction_id: "Transaction Id",
  transaction_time: "Transaction  Time",
 application_list:"Application List",
  transaction_declined: "Transaction Declined",
  period_of_license: "Period of License",
  enclosure: "Enclosures",
  photo: "Photo",
  Signature: "Signature",
  application_id: "Application ID",
  license_period: "License Period",
  apmc: "APMC",
  applied_date: "Applied Date",
  application_status: "Application Status",
  action: "Action",
  payment_status: "Thank you! Your application",
  payment_s:"Sorry! Your payment has failed. Please retry your payment.",
  download_license: "Download License",
  license_validity: "License Validity Upto",
  download_nc_report: "Download NC Report",
  view_comment: "Application status",
  commentt:"Comments Timeline",
  comment:"Comment",
  c_by:"Comment By:",
  approve: "Approve",
  decline: "Decline",
  identified_issues: "Identified Issues",
  make_corection: "Make Correction",
  add_comment: "Add Comment",
  forward: "Forward for",
  select_action: "Select Action",
  add: "Add",
  reset: "Reset",
  record_issues: "Record Issues & Add Remark",
  upload_nc: "Upload NC (Non Conformance) Report",
 tap:"Trader  Application Preview",
 app_details:"Application Details",
 fee:"License Fee ",
 fees:"License Fee of ",
 year:"Year",
 upf:"Upload PDF File",
 usl:"Upload Sealed License",
 dul:"Download Unsigned License",
 approvedunsigned_h1:"This license has been approved by the District Registrar. Additional steps are required for issuing the sealed license to the trader.",
 approvedunsigned_h1_GCA:"This license has been approved by the District Registrar. Additional steps are required for issuing the sealed license to the GCA.",
 approvedunsigned_h2:"Steps for Issuing a Sealed License to the Trader:",
 approvedunsigned_h2_GCA:"Steps for Issuing a Sealed License to the GCA:",
 approvedunsigned_s1:"Download the Approved Unsigned License",
 approvedunsigned_s2:"Obtain the Signature of the Authorized Authority and Affix the Official Seal.",
 approvedunsigned_s3:"Upload the Sealed and Signed License to the System",
 approvedunsigned_panel_h1:"This license has been approved by the Director. Additional steps are required for issuing the sealed license to the Panel.",
 approvedunsigned_panel_h2:"Steps for Issuing a Sealed License to the Panel:",
 upload_doc:"Upload Documents",
 re_info:"Required Information",
 reu_info:"Your application is under Query please provide below information to re-submit the application",
 track_app:"Track  Application ",
 rej_da:"Raise Query data for resubmission",
 rej_doc:"Raise Query documents for resubmission",
 dlusl:"Download License & Upload Signed License",
 order_id:"Order ID",
  //panel engineer
  DOB:"DOB",
  dob:"DOB",
  education_details:"Education Details",
  address_details:"Address Details",
  enter_details:"Enter Details for License Application",
  secondaryDistrict:"Border District",
  full_address:"Full Address",
  "Permanent Address" :"Permanent Address",
  applicant_name:"Applicant Name",
  panel_n:"Panel Engineer Name",
  add_partner:"Add Partner",
  partnership_firm:"Is this a partnership firm?",
  partner_details:"Partner Details",
  add_partner_details:"Add Partner Details",
  save_partner:"Save Partner",
  age:"Age",
  fill:"Fill",
fill_education:"Fill Education Details-",
  education:"Education",
  attested_copy:"Attested copy to be attached",
  experience_details:"Experience Details",
  h_experience_details:"Attach a certified copy of the evidence (minimum 4 years of evidence in case of master's degree / minimum 5 years of evidence in case of bachelor's degree) ",
  project_name:"Project Name",
  project_awarded_by:"Project Awarded By",
  start_date:"Start Date",
  end_date:"End Date",
  projectAwardedby:"Project Awarded By",
  business_engineer:"How many years have you been working as a business engineer?",
  it_returns:"IT returns for the last three years",
  work_performed:"Work Performed  Details",
  h_work_performed:"Details of any government or semi-government office work performed(Year by year project name)",
  done_construction:"Done Construction  Details",
  h_done_construction:"If construction has been done in the market committee and public institution, its details should be given along with the supporting documents.(Annual Market Committee Project Name/Public Organization Project Name)",
  applicant_declaration:"Applicant Declaration",
  submit_application:"Submit Application",
  done:"Done",
  submitted_successfully:"Submitted Successfully",
  attachement:"Attachement",
  download_sealed_license:"Download Sealed License",
  upload_sealed_license:"Upload Sealed License",
  profile_score:"Profile Score",
  panel_engineer_preview:"Panel Engineer  Application Preview",
  complete:"Please Complete Your Application",
  Down_lic:"Download License",
  ex_gst:"Excluding GST",

  status:"Status",

  experienceDoc_1:"Experience Detail One",
  experienceDoc_2:"Experience Detail Two",
  experienceDoc_3:"Experience Detail Three",
  workPerformanceDoc_1:"Work Performed Detail One",
  workPerformanceDoc_2:"Work Performed Detail Two",
  workPerformanceDoc_3:"Work Performed Detail Three",
  constructionDocs_1:"Construction Done Details One",
  constructionDocs_2:"Construction Done Details Two",
  constructionDocs_3:"Construction Done Details Three",


  support:"Support",
  help_supp:"Help & Support",
  sel_role:"Select Role",
  dist_reg:"District Registrar",
  ho_office:"Head Office",
  issue:"Issues",
  forgot_head:"If you forgot your password, we’ll email you an OTP to reset your password.",
 return_to:"Return to",
 sel_tit:"Select Title",
 mr:"Mr.",
 mrs:"Mrs.",
 miss:"Miss.",
 sel_gen:"Select Gender",
 male:"Male",
 female:"Female",
 other:"Other",
 sel_app_type:"Select Applicant Type",
 individual:"Individual",
 company:"Company",
 fir:"Firm",
 co_soc:"Cooperative Society",
 fpoo:"Farmer Producer Organization (FPO)",
 ge:"Government Entity",
 ngo:"Non-Governmental Organization (NGO)",
 pa_fir:" Partnership Firm",
 llp:"Limited Liability Partnership (LLP)",
 trust:"Trust",
 jv:"Joint Venture",
 dgto:"Didn't get the OTP",
 res_pass:"Reset Password",
 verifying:"Verifying",
 en_otp:" Enter OTP",
 succ:"Success",
 bts:"Back to sign-in",
 p_reset:"Your new password has been successfully saved.",
 sel_qual:"Select Qualification",
 hs:"High School",
 yrOfExpAsBusErr:"Year of Experience as Business Engineer",
 highSchool:"High School",
 diploma:"Diploma",
 currAddress:"Current Address",
 bd:"Bachelor's Degree",
 bachelorDegree:"Bachelor's Degree",
 md:"Master's Degree",
 mastersDegree:"Master's Degree",
 phd:"PhD",
 file_type:"Allowed file types: PDF, JPG, JPEG & Max size: 10MB & Min size:40KB",
 uf:"Uploaded File",
 fn:"FileName",
 dn:"Document Name",
 tra_ph:"Trader Photo",
 struct_eng:"Are you a structural engineer?",
 structuralDetail:"Structural Engineer",
 relevant_doc:"Upload the relevant document",
 specialization:"Specialization",
 mobileNo:"Mobile No",
 guarantorPanCard_1:"Guarantor 1 Pan Card",
  guarantorPanCard_2:"Guarantor 2 Pan Card",
  guarantorPhoto_1:"Guarantor 1 Photo",
  guarantorPhoto_2:"Guarantor 2 Photo",
  guarantorSignature_1:"Guarantor 1 Signature",
  guarantorSignature_2:"Guarantor 2 Signature",
  guarantorDetail_2:"Guarantor 2 Details",
  guarantorDetail_1:"Guarantor 1 Details",
  structureErrDoc: "Structural Engineering Document",
  apmc_name:"APMC Name"
};
